export default function Hero() {
  const stats = [
    { value: '10000+', label: '漫画资源' },
    { value: '200+', label: '每日更新/话' },
    { value: '99.9%', label: '无广告纯净阅读' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center pt-16 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 w-full">
          {/* Left Content */}
          <div className="flex-1 w-full">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              日漫 · 韩漫 · 国漫 一网打尽
            </span>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              古古漫画网 - 免费全集下拉式阅读漫画平台
            </h1>

            <p className="text-base md:text-lg text-accent-600 font-medium mb-6">
              好看的漫画免费在线看全集，最新连载实时更新
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mb-8">
              古古漫画网汇聚海量日漫、韩漫、国漫资源，采用极致流畅的下拉式阅读体验，让你一口气畅读全集不中断。平台每日同步各大漫画平台最新连载，确保你第一时间追更心仪作品。无论热血战斗、甜蜜恋爱还是悬疑推理，这里都有你想要的漫画大全。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center gap-6 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="flex items-center gap-2">
                  <span className="text-xl md:text-2xl font-bold text-primary-500">{s.value}</span>
                  <span className="text-xs md:text-sm text-foreground-500">{s.label}</span>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-book-read-line"></i>
                开始阅读
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-foreground-700 font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-trophy-line"></i>
                查看榜单
              </a>
            </div>
          </div>

          {/* Right Visual */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20young%20person%20sitting%20comfortably%20on%20a%20couch%20reading%20manga%20on%20a%20tablet%2C%20surrounded%20by%20manga%20books%20and%20warm%20ambient%20lighting%2C%20manga%20illustration%20art%20style%20with%20vibrant%20colors%20and%20dynamic%20composition%2C%20cozy%20reading%20atmosphere%20with%20bookshelves%20in%20background%2C%20soft%20golden%20hour%20light%20streaming%20through%20window%2C%20modern%20interior%20with%20warm%20wood%20tones&width=800&height=600&seq=hero-manga-001&orientation=landscape"
                alt="古古漫画网 - 沉浸式漫画阅读体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>

              {/* Floating badges */}
              <div className="absolute top-4 left-4 bg-background-50/90 backdrop-blur-sm rounded-lg px-3 py-1.5 text-xs font-medium text-primary-600 flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                连载更新中
              </div>
              <div className="absolute bottom-4 right-4 bg-background-50/90 backdrop-blur-sm rounded-lg px-3 py-1.5 text-xs font-medium text-foreground-600 flex items-center gap-1.5">
                <i className="ri-star-fill text-accent-500 text-sm"></i>
                高清画质
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}